/**
 * currentOrganizationId selectors
 */
interface State {
    currentOrganizationId: string;
}

const selectCurrentOrganizationId = (state: State) =>
    state.currentOrganizationId;

export { selectCurrentOrganizationId };
